import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/articles";

interface BreadcrumbProps {
  currentTitle?: string;
}

export default function Breadcrumb({ currentTitle }: BreadcrumbProps) {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  const breadcrumbs: { label: string; href?: string }[] = [
    { label: "首页", href: "/" },
  ];

  if (pathSegments[0] === "category" && pathSegments[1]) {
    const cat = categories.find((c) => c.slug === pathSegments[1]);
    breadcrumbs.push({ label: cat ? cat.name : pathSegments[1] });
  } else if (pathSegments[0] === "article") {
    breadcrumbs.push({ label: "文章" });
    if (currentTitle) {
      breadcrumbs.push({ label: currentTitle });
    }
  } else if (pathSegments[0] === "about") {
    breadcrumbs.push({ label: "关于我们" });
  }

  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center flex-wrap gap-1.5 text-sm text-foreground-600">
        {breadcrumbs.map((crumb, index) => (
          <li key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            )}
            {crumb.href && index < breadcrumbs.length - 1 ? (
              <Link
                to={crumb.href}
                className="text-foreground-600 hover:text-primary-500 transition-colors no-underline"
              >
                {crumb.label}
              </Link>
            ) : (
              <span className={index === breadcrumbs.length - 1 ? "text-foreground-950 font-medium" : ""}>
                {crumb.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}